const validateString = (str, minLength, regex) => {
  if (typeof str === 'undefined') str = '';

  const matches = str.match(regex);

  const tooShort = str.length < minLength;
  const illegalCharacters = matches != null;

  const result = {
    valid: !tooShort && !illegalCharacters,
    tooShort,
    illegalCharacters
  };

  return result;
};

module.exports = {
  validateString
};
